import React from "react";
import { Button, Icon } from "@chakra-ui/react";
import {
  MenuContent,
  MenuItem,
  MenuRoot,
  MenuTrigger,
} from "../../ui/menu"; // Adjust this path to your project structure
import { iconMap } from "../../../utils/iconMap";

const ActionMenu = ({ row, actions = [], iconKey = "ACTION_DOTS", name, color = "", textColor = "" }) => {
    // Support both static actions array and dynamic function that generates actions per row
    const actionList = typeof actions === 'function' ? actions(row) : actions;
    
    return (
        <MenuRoot>
            <MenuTrigger asChild>
                <Button variant="surface" size="sm" bg={color} color={textColor}>
                    <Icon as={iconMap[iconKey]} />
                    {name}
                </Button>
            </MenuTrigger>
            <MenuContent>
                {actionList.map((action) => (
                    <MenuItem
                        key={action.name}
                        value={action.name}
                        onClick={() => !action.disabled && action.function(row)}
                        disabled={action.disabled}
                        css={{cursor: action.disabled ? "not-allowed" : "pointer", opacity: action.disabled ? 0.5 : 1}}
                    >
                        {action.icon && action.icon}
                        {action.name}
                    </MenuItem>
                ))}
            </MenuContent>
        </MenuRoot>
    );
};

export default ActionMenu;
